__turbopack_context__.v({
  "badge": "uE0fUG_badge",
  "badgeText": "uE0fUG_badgeText",
  "businessProductCard": "uE0fUG_businessProductCard",
  "buttonModal": "uE0fUG_buttonModal",
  "description": "uE0fUG_description",
  "detailsRow": "uE0fUG_detailsRow",
  "header": "uE0fUG_header",
  "headerBlock": "uE0fUG_headerBlock",
  "priceBlok": "uE0fUG_priceBlok",
  "subheader": "uE0fUG_subheader",
  "teaser": "uE0fUG_teaser",
});
